import { useEffect } from 'react';

export function usePostMessageResize() {
  useEffect(() => {
    let lastHeight: number | null = null;
    let rafId: number | null = null;
    let timeoutId: ReturnType<typeof window.setTimeout> | null = null;
    let lastSentAt = 0;

    const sendHeight = () => {
      const height = document.body.scrollHeight;
      if (lastHeight === height) return;
      lastHeight = height;
      parent.postMessage({ iframeHeight: height }, '*');
    };

    const scheduleSendHeight = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        const now = Date.now();
        const elapsed = now - lastSentAt;
        const delay = 500 - elapsed;
        if (delay <= 0) {
          lastSentAt = now;
          sendHeight();
          return;
        }
        if (timeoutId !== null) return;
        timeoutId = setTimeout(() => {
          timeoutId = null;
          lastSentAt = Date.now();
          sendHeight();
        }, delay);
      });
    };

    let observer: ResizeObserver | null = null;
    let interval: ReturnType<typeof setInterval> | null = null;

    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(scheduleSendHeight);
      observer.observe(document.body);
    } else {
      interval = setInterval(scheduleSendHeight, 500);
    }

    window.addEventListener('load', scheduleSendHeight);

    return () => {
      if (rafId !== null) cancelAnimationFrame(rafId);
      if (timeoutId !== null) window.clearTimeout(timeoutId);
      if (observer) observer.disconnect();
      if (interval !== null) clearInterval(interval);
      window.removeEventListener('load', scheduleSendHeight);
    };
  }, []);
}
